import React from "react"
import { ContentHomePageHeading } from "./Content/ContentHomePageHeading"
import { ContentHomePageCategories } from "./Content/ContentHomePageCategories"
import { ContentAboutMePageIntroAboutMe } from "./Content/ContentAboutMePageIntroAboutMe"
import { ContentAboutMePageCompanyLogos } from "./Content/ContentAboutMePageCompanyLogos"
import { translation } from "../../helper/translation"

export const PartialAboutMePage = () => {
    return(
        <React.Fragment>
            <ContentHomePageHeading breadcrumb={translation("about-me")} />
            <ContentHomePageCategories />
            <ContentAboutMePageIntroAboutMe />
            <ContentAboutMePageCompanyLogos />
        </React.Fragment>
    )
}